import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { SHARED_UI_LABELS } from '@/config/task-display-config';

export default function FounderFilters({ filters, onFilterChange, onSearchChange, search }) {
  const contactStatuses = ['Not Contacted', 'Contacted', 'Replied', 'Meeting Scheduled', 'Meeting Completed'];
  const emailStatuses = ['Valid', 'Invalid', 'Bounced', 'Unsubscribed', 'Added'];

  return (
    <div className="bg-white p-4 rounded-lg shadow mb-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Search */}
        <div>
          <Label className="mb-2 block">Search</Label>
          <Input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={SHARED_UI_LABELS.searchByNameOrEmail}
          />
        </div>

        {/* Startup Name */}
        <div>
          <Label className="mb-2 block">Startup</Label>
          <Input
            type="text"
            value={filters.startup_name}
            onChange={(e) => onFilterChange({ ...filters, startup_name: e.target.value })}
            placeholder={SHARED_UI_LABELS.filterByStartup}
          />
        </div>

        {/* Contact Status */}
        <div>
          <Label className="mb-2 block">Contact Status</Label>
          <Select
            value={filters.contact_status}
            onValueChange={(value) => onFilterChange({ ...filters, contact_status: value })}
          >
            <SelectTrigger>
              <SelectValue placeholder="All" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              {contactStatuses.map(status => (
                <SelectItem key={status} value={status}>{status}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Email Status */}
        <div>
          <Label className="mb-2 block">Email Status</Label>
          <Select
            value={filters.email_status}
            onValueChange={(value) => onFilterChange({ ...filters, email_status: value })}
          >
            <SelectTrigger>
              <SelectValue placeholder="All" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              {emailStatuses.map(status => (
                <SelectItem key={status} value={status}>{status}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
